var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 907,
    viewBox: "0 0 1080 907",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4916_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.459 40H236.541C127.994 40 40 127.994 40 236.541V669.819C40 778.366 127.994 866.36 236.541 866.36H843.459C952.006 866.36 1040 778.366 1040 669.819V236.541C1040 127.994 952.006 40 843.459 40Z",
    fill: "url(#paint0_linear_4916_711)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.639 268.074C155.639 268.074 337.738 592.17 360.739 617.107C383.74 642.044 400.753 653.33 437.842 653.33C474.931 653.33 497.071 636.25 510.77 617.107C524.469 597.964 679.108 339.075 679.108 339.075C679.108 339.075 648.502 326.311 619.902 326.311C591.301 326.311 573.39 334.114 557.164 351.209C540.937 368.304 430.084 553.112 430.084 553.112C430.084 553.112 290.613 295.602 272.134 278.216C253.656 260.83 244.208 255.651 214.813 253.53C185.419 251.41 155.639 268.074 155.639 268.074Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M921.854 269.859C921.854 269.859 729.299 607.391 709.983 625.869C690.667 644.348 681.565 649.114 651.723 652.127C621.88 655.14 590.95 639.104 590.95 639.104C590.95 639.104 783.11 304.558 796.324 287.791C809.537 271.024 824.883 259.924 856.267 255.445C887.65 250.966 921.854 269.859 921.854 269.859Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4916_711",
    x: 0,
    y: 0,
    width: 1080,
    height: 906.36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.317647 0 0 0 0 0.984314 0 0 0 0.153 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4916_711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4916_711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4916_711",
    x1: 540,
    y1: 40,
    x2: 540,
    y2: 866.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DF0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLast);
export default __webpack_public_path__ + "static/media/logoLast.8666f181be8ab6f6411601bef98cb994.svg";
export { ForwardRef as ReactComponent };